import React from 'react';
import { Link } from 'gatsby';

//Common application components
import Layout from '../../components/layout';

//Page application components
import Data from './data.json';

//Styles
import './styles.scss';

const NotFoundPage = () => {
  return (
    <Layout title={Data.title} meta={Data.meta}>
      <div className="error_main container">
        <h1 className="error_main_h1">
          Desculpe, mas a página requisitada não pôde ser encontrada.
        </h1>
        <Link className="error_main_link" to="/">
          Voltar para a página inicial
        </Link>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
